import React, { useEffect } from 'react';
import { useState } from "react";
import { SearchableDropdown } from "../helpers/SearchableDropdown";
import { Dropdown } from "../helpers/Dropdown";
import { getText } from '../../i18n';

const PropertiesEnrollmentByAge = ({item, setItem}) => {

    const [selectedPlanTypes, setSelectedPlanTypes] = useState([]);
    const [ageRanges, setAgeRanges] = useState([]); // Initialize with one row
    const [areInputsDisabled, setAreInputsDisabled] = useState(false);
    const [optionsForDropdown, setOptionsForDropdown] = useState([]);
    const [applyDataView, setApplyDataView] = useState(false);

    const [planTypes, setPlanTypes] = useState([
        {
            id: 1,
            name: "Medical",
            checked: false
        },
        {
            id: 2,
            name: "Dental",
            checked: false
        },
        {
            id: 3,
            name: "Vision",
            checked: false
        },
        {
            id: 4,
            name: "Healthcare FSA",
            checked: false
        },
        {
            id: 5,
            name: "Dependent Care FSA",
            checked: false
        },
        {
            id: 6,
            name: "Limited Purpose FSA",
            checked: false
        },
        {
            id: 7,
            name: "HSA",
            checked: false
        },
        {
            id: 8,
            name: "HRA",
            checked: false
        },
        {
            id: 9,
            name: "LTD",
            checked: false
        },
        {
            id: 10,
            name: "STD",
            checked: false
        },
        {
            id: 11,
            name: "Basic Life",
            checked: false
        },
        {
            id: 12,
            name: "Vol EE Life",
            checked: false
        },
        {
            id: 13,
            name: "Vol Spouse Life",
            checked: false
        },
        {
            id: 14,
            name: "Vol Child Life",
            checked: false
        },
        {
            id: 15,
            name: "Whole Life",
            checked: false
        },
        {
            id: 16,
            name: "Hospital Indemnity",
            checked: false
        },
        {
            id: 17,
            name: "Critical Illness",
            checked: false
        },
        {
            id: 18,
            name: "Accident",
            checked: false
        },
        {
            id: 19,
            name: "Cancer",
            checked: false
        },
        {
            id: 20,
            name: "Legal",
            checked: false
        },
        {
            id: 21,
            name: "Identify Theft",
            checked: false
        },
        {
            id: 22,
            name: "Pet Insurance",
            checked: false
        },
        {
            id: 23,
            name: "Beneficiary Companion",
            checked: false
        },
        {
            id: 24,
            name: "401K",
            checked: false
        },
        {
            id: 25,
            name: "401K Roth",
            checked: false
        },
        {
            id: 26,
            name: "403B",
            checked: false
        }
    ].map((planType) => {
        return {
            id: planType.id,
            name: planType.name
        }
    }));

    const computeItemDataFromViewData = () => {
        let newPlanTypes = selectedPlanTypes;
        const newAgeBandParts = [];
        
        ageRanges.forEach(ageBand => {
            newPlanTypes.forEach(planTypeID => {
                newAgeBandParts.push({
                    PlanTypeId: planTypeID,
                    LowerBound: ageBand.min,
                    UpperBound: ageBand.max === 'None' ? 99 : parseInt(ageBand.max)
                });
            });
        });

        console.log('setting age band parts in item: ',newAgeBandParts);

        setItem(prevState => ({
            ...prevState,
            ageBandParts: newAgeBandParts
        }));
    }

    useEffect(() => {
        computeViewDataFromItemData();
    }, []);

    useEffect(() => {
        computeItemDataFromViewData();

        if (item !== undefined) {
            if(item.hasOwnProperty("templateStatus")){
                if(item.templateStatus===-1){
                    //Template is locked, activate view-only mode
                    console.log(item.templateStatus);
                    setAreInputsDisabled(true);
                }
            }
        }

    }, [selectedPlanTypes]);

    const handleMaxChange = (index, selectedMax) => {
        let updatedAgeRanges = [...ageRanges];
        updatedAgeRanges[index].max = selectedMax;
        //decide whether to add another row
        setAgeRanges(updatedAgeRanges);
        computeAgeRangesFromViewData(updatedAgeRanges);
        computeItemDataFromViewData();
    };

    const computeAgeRangesFromViewData = (updatedAgeRanges) => {
        if (updatedAgeRanges.length === 0) {
            updatedAgeRanges = [{
                min: 0,
                max: 'None'
            }];
        }
        else if (
            updatedAgeRanges[updatedAgeRanges.length - 1].max !== 'None' &&
            updatedAgeRanges[updatedAgeRanges.length - 1].max < 99
        ) {
            updatedAgeRanges.push({
                min: Number(updatedAgeRanges[updatedAgeRanges.length - 1].max) + 1,
                max: 'None'
            });
        }
        setAgeRanges(updatedAgeRanges);

        let minValue = 
            updatedAgeRanges[updatedAgeRanges.length - 1].max !== 'None' ?
            Number(updatedAgeRanges[updatedAgeRanges.length - 1].max) + 1 : 
            Number(updatedAgeRanges[updatedAgeRanges.length - 1].min) + 1;

        let options = [{ value: '', label: getText('msg_6eef6648406c') }]; // Allows clearing the selection
        for (let i = minValue; i <= 99; i++) {
            options.push({ value: i.toString(), label: `${i}` });
        }

        setOptionsForDropdown(options);
    };

    //this will probably turn into a function to compute the view data 
    //this is a special case - the model data is way more complicated than the view data
    //so it breaks the MVC pattern somewhat, because the source of truth should be the
    //bands and plans, not the individual records.
    
    const computeViewDataFromItemData = () => {
        // TODO: set checked true
        // TODO: this was just pasted in here and probably needs to be formatted better or put in a more sensible place
        // TODO: Replace with actual saved/selected plan types for container

        setApplyDataView(item.applyDataFilter || false);

        function getPlanTypeByID (ID) {
            let planType = null;
            planTypes.forEach((p) => {
                if (`${p.id}` === `${ID}`) {
                    planType = p;
                }
            });
            return planType;
        }

        //compute array of age ranges from age band parts
        //these have different names in template and container calls
        // let ageBandParts = (item.data && item.data.ageBands) || item.ageBandParts;
        let ageBandParts = item.ageBandParts;
        //get unique plan types

        let enteredUniquePlanType = {};
        let uniquePlanTypes = [];

        let enteredUniqueAgeRange = {};
        let uniqueAgeRanges = [];

        ageBandParts.forEach((ageBandPart) => {
            //enter all the unique age bands, indexed by bounds
            if (!enteredUniqueAgeRange[`${ageBandPart.lowerBound}${ageBandPart.upperBound}`]) {
                uniqueAgeRanges.push({
                    min: ageBandPart.lowerBound,
                    max: ageBandPart.upperBound
                });
            }
            enteredUniqueAgeRange[`${ageBandPart.lowerBound}${ageBandPart.upperBound}`] = true;

            //enter all the unique plan types, indexed by id
            if (!enteredUniquePlanType[`${ageBandPart.planTypeId}`]) {
                uniquePlanTypes.push(getPlanTypeByID(ageBandPart.planTypeId));
            }
            enteredUniquePlanType[`${ageBandPart.planTypeId}`] = true;
        });

        // if (uniqueAgeRanges.length === 0) {
        //     uniqueAgeRanges = [{
        //         min: 0,
        //         max: 'None'
        //     }];
        // }
        // else if (
        //     uniqueAgeRanges[uniqueAgeRanges.length - 1].max !== 'None' &&
        //     uniqueAgeRanges[uniqueAgeRanges.length - 1].max < 99
        // ) {
        //     uniqueAgeRanges.push({
        //         min: Number(uniqueAgeRanges[uniqueAgeRanges.length - 1].max) + 1,
        //         max: 'None'
        //     });
        // }

        // let minValue = 
        //     uniqueAgeRanges[uniqueAgeRanges.length - 1].max !== 'None' ?
        //     Number(uniqueAgeRanges[uniqueAgeRanges.length - 1].max) + 1 : 
        //     Number(uniqueAgeRanges[uniqueAgeRanges.length - 1].min) + 1;

        // let options = [{ value: '', label: "None" }]; // Allows clearing the selection
        // for (let i = minValue; i <= 99; i++) {
        //     options.push({ value: i.toString(), label: `${i}` });
        // }
        // 
        
        setAgeRanges(uniqueAgeRanges);
        let newSelectedPlanTypes = uniquePlanTypes.map((planType) => {
            console.log('plan type id',planType.id);
            return planType.id;
        });
        setSelectedPlanTypes(newSelectedPlanTypes);
        computeAgeRangesFromViewData(uniqueAgeRanges);
    };

    const tempSetSelectedPlanTypes = (types) => {
        setSelectedPlanTypes(types.map((type) => {
            return type.id;
        }));
    }

    useEffect(() => {
        setItem(prevState => ({
            ...prevState,
            applyDataFilter: applyDataView
        }));
    }, [applyDataView]);

    return (
        <>

            <div style={{ margin: "26px 0px 0px 0px", display: "flex", alignItems: "center", lineHeight: "28px" }}>
                <input
                    type="checkbox"
                    className="form-check-input custom-checkbox"
                    checked={applyDataView}
                    onChange={() => {
                        setApplyDataView(!applyDataView);
                    }}
                    disabled={areInputsDisabled}
                />
                <span style={{ color: "#2F2B43", fontWeight: "500", fontSize: "16px" }}>{getText('msg_9d8480cea43b')}</span>
            </div>

            <div style={{ fontSize: "16px", fontWeight: "500", color: "rgba(47, 43, 67, 1)", marginTop: "26px", marginBottom: "10px" }}>{getText('msg_1c46045e9b77')} <span style={{ color: "#EF4E45", marginLeft: "4px", fontWeight: "500" }}>*</span></div>
            <SearchableDropdown options={planTypes} optionIDField="id" updateOptions={tempSetSelectedPlanTypes} savedOptions={selectedPlanTypes} disabled={areInputsDisabled}/>

            <div style={{ fontSize: "16px", fontWeight: "500", color: "rgba(47, 43, 67, 1)", marginTop: "26px", marginBottom: "10px" }}>{getText('msg_99d1f56e9eb5')}</div>
            {ageRanges.map((range, index) => (
                <div key={index} style={{ width: "100%", display: "flex", flexDirection: "row", marginBottom: "10px" }}>
                    <input
                        value={range.min}
                        style={{ width: "120px", height: "48px", borderRadius: "12px", border: "solid 1px rgba(47, 43, 67, 0.2)", paddingLeft: "16px", paddingRight: "16px", textAlign: "center" }}
                        className="form-control"
                        readOnly
                        disabled={areInputsDisabled}
                    />
                    <span style={{ alignSelf: "center", margin: "0px 10px" }}>{getText('msg_4374aaee247f')}</span>
                    <div style={{ width: "120px", height: "48px", textAlign: "center" }}>
                        <Dropdown
                            defaultValue={range.max}
                            options={optionsForDropdown}
                            onChange={(value) => handleMaxChange(index, value)}
                            disabled={areInputsDisabled}
                        />
                    </div>
                    <span style={{ color: "#EF4E45", marginLeft: "4px", fontWeight: "500", display: index === 0 ? "block" : "none" }}>*</span>
                </div>
            ))}
        </>
    );
};

export default PropertiesEnrollmentByAge;
